import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../../constants/common'
import { ActionSelect } from '../../../../../../Action'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../../Button'
import { QA_NAME_LISTING_PUBLICATION_ACTIONS_MENU } from '../ListingProfilePublishingsActionsCell.constants'

import * as styles from './ListingProfilePublishingsActionsMenu.module.css'

function ListingProfilePublishingsActionsMenu({
  isDisabled,
  options,
  tooltipContent,
  onCallAction,
}) {
  function handleClickAction(option) {
    onCallAction(option.value)
  }

  return (
    <ActionSelect
      actions={options}
      className={styles.ListingProfilePublishingsActionsMenu}
      controlProps={{
        buttonProps: {
          Button: Button.Text,
          className: styles.controlButton,
          disabled: isDisabled,
          height: BUTTON_HEIGHT_24,
          qaName: QA_NAME_LISTING_PUBLICATION_ACTIONS_MENU,
          tooltip: isDisabled ? tooltipContent : null,
          tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.top,
        },
      }}
      disabled={isDisabled}
      qaName={QA_NAME_LISTING_PUBLICATION_ACTIONS_MENU}
      onClickAction={handleClickAction}
    />
  )
}

export default ListingProfilePublishingsActionsMenu
